export async function saveProfileSystem(URL, token, data, file) {
  return data.id
    ? updateProfileSystem(URL, token, data, file)
    : createProfileSystem(URL, token, data, file);
}

export async function createProfileSystem(URL, token, data, file) {
  try {
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: "application/json",
    });
    const formData = new FormData();
    formData.append("data", blob);
    formData.append("file", file);
    const response = await fetch(URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    if (response.ok) {
      return {
        success: true,
        status: response.status,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
        message: `The error status code is ${response.status}`,
      };
    }
  } catch (err) {
    return {
      success: false,
      message: err.message,
    };
  }
}

async function updateProfileSystem(URL, token, data, file) {
  try {
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: "application/json",
    });
    const formData = new FormData();
    formData.append("data", blob);
    formData.append("file", file);
    const response = await fetch(URL, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    if (response.ok) {
      return {
        success: true,
        status: response.status,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
        message: `The error status code is ${response.status}`,
      };
    }
  } catch (err) {
    return {
      success: false,
      message: err.message,
    };
  }
}
